import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';


const index = ReactDOM.createRoot(document.getElementById('index'));
index.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

